import { emailSchema, standardStringSchema } from "@/schemas"
import { z } from "zod"

export const loginSchema = z.object({
  email: emailSchema,
  password: standardStringSchema.min(1),
})

export type LoginSchema = z.infer<typeof loginSchema>
